import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Fetch all restaurants
 * @returns {Promise<Object>} - Response data from the API
 */
export const getAllRestaurants = async () => {
  try {
    const response = await apiClient.get(
      `${API_ENDPOINTS.ALL_RESTAURANTS}?country_id=3`
    );
    return response.data.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
